export default __webpack_public_path__ + "static/media/pic4.2311c7f5.jpg";